// UPA Brand Assets
export const UPA_LOGO_URL = 'https://customer-assets.emergentagent.com/job_4cf29391-a054-46ca-8c58-6d2c15185384/artifacts/8pkzw5ql_white%20gradient.png';

// Fallback image for classes, bootcamps, etc.
export const DEFAULT_CLASS_IMAGE = UPA_LOGO_URL;
export const DEFAULT_BOOTCAMP_IMAGE = UPA_LOGO_URL;
export const DEFAULT_TEACHER_IMAGE = UPA_LOGO_URL;
